const setCookie = (name, value, days) => {
  let expires = '';
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = `; expires=${date.toUTCString()}`;
  }
  document.cookie = `${name}=${value || ''}${expires}; path=/`;
};

const getCookie = (name) => {
  const nameEQ = `${name}=`;
  const ca = document.cookie.split(';');
  for (let c of ca) {
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};

document.addEventListener('DOMContentLoaded', () => {
  const popupWrapper = document.querySelector('.popup-wrapper');
  if (!popupWrapper) return;

  const hasSuccess = !!popupWrapper.querySelector('.popup-success');

  popupWrapper.style.display = hasSuccess ? 'block' : 'none';

  const closeControls = document.querySelectorAll('.cancel-link, [data-popup-close]');
  closeControls.forEach((control) => {
    control.addEventListener('click', (e) => {
      e.preventDefault();
      popupWrapper.style.display = 'none';
      const futureDate = new Date();
      futureDate.setDate(futureDate.getDate() + 30);
      setCookie('hidePopup', futureDate, 30);
    });
  });

  popupWrapper.addEventListener('click', (e) => {
    if (e.target === popupWrapper || e.target.classList.contains('popup-box__bg')) {
      popupWrapper.style.display = 'none';
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && popupWrapper.style.display === 'block') {
      popupWrapper.style.display = 'none';
      return;
    }
    if (e.key !== 'Enter' && e.key !== ' ') return;
    const trigger = e.target.closest('[data-open-popup]');
    if (!trigger) return;
    e.preventDefault();
    popupWrapper.style.display = 'block';
  });

  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-open-popup]');
    if (!trigger) return;
    e.preventDefault();
    popupWrapper.style.display = 'block';
  });

  const copyTrigger = popupWrapper.querySelector('[data-copy-trigger]');
  if (copyTrigger) {
    copyTrigger.addEventListener('click', () => {
      const codeEl = popupWrapper.querySelector('[data-copy-code]');
      if (!codeEl) return;
      const text = codeEl.textContent.trim();
      const done = () => {
        const original = copyTrigger.textContent;
        copyTrigger.textContent = 'Copied';
        copyTrigger.classList.add('is-copied');
        setTimeout(() => {
          copyTrigger.textContent = original;
          copyTrigger.classList.remove('is-copied');
        }, 2000);
      };
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(text).then(done).catch(done);
      } else {
        const temp = document.createElement('textarea');
        temp.value = text;
        temp.style.position = 'fixed';
        temp.style.opacity = '0';
        document.body.appendChild(temp);
        temp.select();
        try { document.execCommand('copy'); } catch (err) {}
        document.body.removeChild(temp);
        done();
      }
    });
  }

  if (hasSuccess) {
    return;
  }

  if (window.location.href.includes('/challenge#popupForm')) {
    return;
  }

  const delaySeconds = parseInt(popupWrapper.getAttribute('data-popup-delay'), 10);
  const delayMs = (isNaN(delaySeconds) ? 5 : delaySeconds) * 1000;

  setTimeout(() => {
    const hidePopup = getCookie('hidePopup');
    if (hidePopup && new Date(hidePopup) > new Date()) return;
    popupWrapper.style.display = 'block';
  }, delayMs);
});
